var LokiConfigError = /** @class */ (function () {
    function LokiConfigError(name, message, rootCorrelationId, isExpected, statusCode, numberOfRetries) {
        this.name = name;
        this.message = message;
        this.rootCorrelationId = rootCorrelationId;
        this.isExpected = isExpected;
        this.statusCode = statusCode;
        this.numberOfRetries = numberOfRetries;
    }
    return LokiConfigError;
}());
export { LokiConfigError };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTG9raUNvbmZpZ0Vycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL0xva2lDb25maWdFcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNFLHlCQUNTLElBQVksRUFDWixPQUFnQixFQUNoQixpQkFBMEIsRUFDMUIsVUFBb0IsRUFDcEIsVUFBbUIsRUFDbkIsZUFBd0I7UUFMeEIsU0FBSSxHQUFKLElBQUksQ0FBUTtRQUNaLFlBQU8sR0FBUCxPQUFPLENBQVM7UUFDaEIsc0JBQWlCLEdBQWpCLGlCQUFpQixDQUFTO1FBQzFCLGVBQVUsR0FBVixVQUFVLENBQVU7UUFDcEIsZUFBVSxHQUFWLFVBQVUsQ0FBUztRQUNuQixvQkFBZSxHQUFmLGVBQWUsQ0FBUztJQUM5QixDQUFDO0lBQ04sc0JBQUM7QUFBRCxDQUFDLEFBVEQsSUFTQyJ9